import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { HOME } from '@/sections';

export function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Result
      status="404"
      title={t('pages.notFound')}
      extra={
        <Button
          type="primary"
          onClick={() => {
            void navigate(HOME);
          }}
        >
          {t('common.toHome')}
        </Button>
      }
    />
  );
}
